import React from 'react';
import { connect } from 'react-redux';
import FreemiumFullScreenCarousel from '../components/FreemiumFullScreenCarousel';

export class Featured extends React.Component {
  render() {
    const { featuredPlaylist } = this.props;

    return (
      <FreemiumFullScreenCarousel
        selectedArtwork={0}
        history={this.props.history}
        playlistName={featuredPlaylist.data.collection.name}
        artworks={featuredPlaylist.data.collection.artwork}
        hasSubscription={typeof this.props.subscription?.data?.plan?.id === 'string'}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  storeHistory: (history) => dispatch(storeHistory(history)),
});

export default connect((state) => {
  const { featuredPlaylist, subscription } = state;
  return {
    featuredPlaylist,
    subscription,
  };
}, mapDispatchToProps)(Featured);
